import { useFetchQuery } from '../../../../hooks/useFetchQuery';
import { REPORTING_SERVICE_V2_PATH } from '../../../../api/constants';

type RelativeDateRange = [string, string] | [];

interface RelativeDateRangeResponse {
  data: RelativeDateRange;
}

interface RelativeDateRangeRequestParams {
  type: string;
  format: 'date' | 'year' | 'period' | '';
  asOf: string;
  rolling?: number;
  fiscalYearStartMonth: number;
  entityTimezone?: string | null;
}

const relativeDateRangeUrl = `${REPORTING_SERVICE_V2_PATH}/reportConfigurations/relativeDateRange`;

export function useGetRelativeDateRange(params: RelativeDateRangeRequestParams): RelativeDateRange {
  const queryParams = new URLSearchParams({
    type: params.type,
    format: params.format,
    asOf: params.asOf,
    fiscalYearStartMonth: params.fiscalYearStartMonth.toString(),
    rolling: Math.max(params.rolling ?? 1, 1).toString(),
    ...(params.entityTimezone ? { entityTimezone: params.entityTimezone } : {})
  });

  const { data, error } = useFetchQuery<RelativeDateRangeResponse>({
    queryKey: ['relativeDateRange', params],
    url: `${relativeDateRangeUrl}?${queryParams.toString()}`,
    method: 'GET',
    enabled: !!params.type && !!params.format && !!params.fiscalYearStartMonth,
    staleTime: 0.5 * 60 * 1000 // 0.5 minutes
  });

  if (error) {
    return [];
  }

  return data?.data ?? [];
}
